module.exports = __webpack_public_path__ + "img/act_icon_03.9c4aa54.png";